module.exports = __webpack_public_path__ + "img/varilux-x-series.165f3616.svg";